import React, {LegacyRef} from 'react';
import {Controller} from 'react-hook-form';
import {Input} from '@chakra-ui/react';

import styles from './styles.module.scss';
import {InputGroup} from '../chakra-ui/input-group';
import classNames from 'classnames';

const InputField: React.FC<{
  control: any;
  name: string;
  label: string;
  rules?: Record<string, any>;
  type: 'text' | 'password';
  error?: string;
  placeholder: string;
  startElement?: any;
  endElement?: any;
  disabled?: boolean;
  inputRef?: LegacyRef<HTMLInputElement> | undefined;
}> = ({
        control,
        name,
        rules = {},
        type,
        error,
        placeholder,
        label,
        startElement,
        endElement = '',
        disabled = false,
        inputRef
      }) => {
  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({field, fieldState, formState}) => {
        const errorMessage = fieldState?.error?.message || error;
        const hasError = !!errorMessage;

        return (
          <label className={styles.inputWrapper}>
            <span className={styles.label}>{label}</span>
            <div className={classNames(styles.input, {
              [styles.startElement]: !!startElement,
              [styles.hasError]: hasError
            })}>
              <InputGroup
                flex="1"
                startElement={startElement}
                startElementProps={{width: '48px'}}
                endElement={endElement}
                {...field}
              >
                <Input
                  placeholder={placeholder}
                  variant="subtle"
                  type={type}
                  {...field}
                  ref={inputRef}
                  style={{
                    background: '#212D40',
                    borderColor: hasError ? '#C5251E' : '#364156'
                  }}
                  disabled={disabled}
                />
              </InputGroup>
              {errorMessage && <div className={styles.error}>{errorMessage}</div>}
            </div>
          </label>
        );
      }}
    />
  );
};

export default InputField;